export const enum Environment {
    Production = 'Production',
    Integration = 'Integration',
    Development = 'Development',
    Local = 'Local',
    Unknown = 'Unknown',
}

export const toEnvironment = (env: string): Environment => {
    const normalized = env?.trim().toLowerCase();
    if (normalized === 'production') {
        return Environment.Production;
    }
    if (normalized === 'integration') {
        return Environment.Integration;
    }
    if (normalized === 'development') {
        return Environment.Development;
    }
    if (normalized === 'local') {
        return Environment.Local;
    }
    return Environment.Unknown;
};

export interface EnvironmentConfigMap<T> {
    development: T;
    integration: T;
    production: T;
    local: T;
}

export const resolveEnvironmentConfig = <T>(env: Environment, configs: EnvironmentConfigMap<T>): T => {
    switch (env) {
        case Environment.Development:
            return configs.development;
        case Environment.Integration:
            return configs.integration;
        case Environment.Production:
            return configs.production;
        case Environment.Local:
            return configs.local;
        case Environment.Unknown:
        default:
            throw new Error('Unrecognised environment: cannot resolve app configuration');
    }
};
